<template>
  <div class="mt-3" v-show="formIsOpen">
    <form @submit.prevent="formSubmit">
      <div class="md6">
        <va-input
          class="mb-4 mx-3"
          v-model="data.name"
          :label="$t('name')"
        />
                        
        <va-input
          class="mb-4 mx-3"
          v-model="data.name_ar"
          :label="$t('name_ar')"
        />
      </div>
      <!-- <div class="md6">
            <va-input
            class="mb-4 mx-3"
            v-model="data.content"
            type="textarea"
            :label="$t('content')"
            />
                        
            <va-input
            class="mb-4 mx-3"
            v-model="data.content_ar"
            type="textarea"
            :label="$t('content_ar')"
            />
        </div> -->
      <div class="md6">
        <va-input
          class="mb-4 mx-3"
          v-model="data.logo"
          type="file"
          id="logo"
          :label="$t('img')"
        />
        <!-- <va-date-input 
                class="mb-4 mx-3"
                v-model="data.valid_thru"
                :label="$t('valid_thru')"
            /> -->
      </div>

      <va-divider inset />
                        
      <div class="card_footer">
        <va-button outline class="mr-4" type="submit">{{$t('save')}}</va-button>
        <va-button outline color="danger" class="mr-4" @click="closeForm">{{$t('cancel')}}</va-button>
      </div>

    </form>
  </div>
</template>

<script>
import { GraphQLClient } from 'graphql-request';
import { ACADEMY_SPONSERS_INSERT } from '@/graphql/mutations/academy/sponsers';
import { ACADEMY_SPONSERS_UPDATE } from '@/graphql/mutations/academy/sponsers';

        
export default {
    props: ["formIsOpen", "selectedRowToEdit"],
    data() {
        return {
            data: {},
        }
    },
    emits: ["closeForm", "rowInserted", "rowUpdated"],
    methods:{
        closeForm(){
            this.$emit('closeForm');
        },
        async formSubmit(){
            console.log(this.data);

            const graphQLClient = new GraphQLClient(this.$store.state.appUrl, {
                headers: {
                    // authorization: 'Bearer MY_TOKEN',
                },
            })

            const variables = {
                "name": this.data.name,
                "name_ar": this.data.name_ar,
                // "content": this.data.content,
                // "content_ar": this.data.content_ar,
                // "valid_thru": this.data.valid_thru,
                "logo": document.querySelector("#logo").files[0],
            }

            let query = "";

            if(!this.data.id){
                // Add Section
                console.log("insert");
                query = ACADEMY_SPONSERS_INSERT    
            } else {
                //edit Section
                query = ACADEMY_SPONSERS_UPDATE   
                variables.id = this.data.id
            }
            try{
                const data = await graphQLClient.request(query, variables)
                console.log(JSON.stringify(data, undefined, 2))
                this.data = {};
                if(this.selectedRowToEdit){
                    this.$emit('rowUpdated', data.AcademyNewsUpdate)
                }else{
                    this.$emit('rowInserted', data.AcademyNewsCreat)
                }
                // this.closeForm();
            }catch(err){
                console.log(err);              
            }
        }
    },
    watch: {
        selectedRowToEdit(n){
            console.log(this.selectedRowToEdit + "asaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa" +n);
            if(this.selectedRowToEdit != {}){
                this.data.id = this.selectedRowToEdit.id;
                this.data.name = this.selectedRowToEdit.name;
                this.data.name_ar = this.selectedRowToEdit.name_ar;
                // this.data.content = this.selectedRowToEdit.content;
                // this.data.content_ar = this.selectedRowToEdit.content_ar;
            }
        }
    },
}
</script>

<style>
.md6{
    display: flex;
}

</style>